/**
 * Mapping of financial statement category keys to their display names
 */
export const CATEGORY_DISPLAY_NAMES: Record<string, string> = {
    'income_statement': 'Income Statement',
    'balance_sheet': 'Balance Sheet',
    'cash_flow_statement': 'Cash Flow Statement',
    'bank_statement_summary': 'Bank Statement Summary',
    'ar_aging': 'Accounts Receivable Aging',
    'ap_aging': 'Accounts Payable Aging'
};

/**
 * Get the display name for a financial statement category
 * @param category - The category key (e.g., 'income_statement')
 * @returns The display name (e.g., 'Income Statement')
 */
export const getCategoryDisplayName = (category: string): string => {
    return CATEGORY_DISPLAY_NAMES[category] || category;
};

